export default __webpack_public_path__ + "static/optimized-operations-3e068512c548a0b9e3a44405a6b486f6.svg";